import { gql } from '@apollo/client';

export const GET_PICKUP_TASK_APPOINTMENT_STATUS = gql`
  query GetPickupTaskAppointmentStatus($appointmentId: Long!, $taskId: Long!) {
    getPickupTaskAppointmentStatus(appointmentId: $appointmentId, taskId: $taskId)
  }
`;

export interface GetPickupTaskAppointmentStatusResponse {
  getPickupTaskAppointmentStatus: string | null;
}
